/**
 * Sentry error tracking, gated entirely on environment.sentryDsn.
 *
 * Every committed environment file (see src/environments/) ships with
 * sentryDsn: '' — initSentry() is then a complete no-op: it never calls
 * Sentry.init(), so no network calls, no global error-listener patching,
 * nothing. Only a build carrying a real DSN turns it on. Mirrors the
 * backend's SENTRY_DSN-gated init in config/settings.py.
 */
import * as Sentry from '@sentry/angular';
import { environment } from '../../environments/environment';

let initialized = false;

export function initSentry(): void {
  if (!environment.sentryDsn) {
    return;
  }
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.production ? 'production' : 'development',
    sendDefaultPii: false,
  });
  initialized = true;
}

/** Safe to call whether or not Sentry was initialized (no-op if not). */
export function captureException(error: unknown): void {
  if (!initialized) return;
  Sentry.captureException(error);
}
